import {
    graphXAxisLabelFontSize,
    groupBarChartWidth,
} from 'components/organism/GrowthAnalysis/BrandValueChartContainer/BrandValueChartContainer';
import { salesTileKeyType } from 'components/pages/CommercialForecast';
import { colorConstants } from 'config/colorConstants';
import { renderTitle } from './getSalesAttributionColumns';
import { formatNumWithKMBAlt } from './helperMethods';
import { salesGraphWidth } from 'components/template/CommercialForecast/CFExpandedView';

export const getCommercialForecastColumns = (data: any, expandedItem: any, drillDownSelectedData: any, width: any) => {
    const result: any = [];
    Object.keys(data[0])?.map((key, idx) => {
        const temp = {
            title:
                key === 'label'
                    ? ''
                    : renderTitle(key, undefined, undefined, 'text-purpleFont !font-bold', graphXAxisLabelFontSize),
            dataIndex: key,
            width: key === 'label' ? 140 : Math.max(width, salesGraphWidth),
            key: key,
            align: idx === 0 ? 'left' : 'center',
            fixed: idx === 0 || idx === 1 ? 'left' : false,
            onCell: (record: any, rowIndex: number) => {
                if (
                    (expandedItem &&
                        'attributeExId' in expandedItem &&
                        expandedItem['attributeExId'] === key?.trim()) ||
                    (drillDownSelectedData &&
                        'attributeExId' in drillDownSelectedData &&
                        drillDownSelectedData['attributeExId'] === key?.trim())
                ) {
                    return {
                        style: {
                            border: `1px solid ${colorConstants.borderGreyAlt}`,
                            background: colorConstants.lightPurple,
                        },
                    };
                }
            },
            // sorter:
            //     idx === 0
            //         ? false
            //         : (a: any, b: any, c: any, d: any) => {
            //               return a[key] - b[key];
            //           },
            render: (columnData: any, rowData: any, index: number) => {
                return (
                    <div
                        // style={{
                        //     ...categoryImpactedCommonStyles,
                        // }}
                        style={{ fontSize: graphXAxisLabelFontSize }}
                    >
                        {columnData}
                    </div>
                );
            },
        };
        result.push(temp);
    });
    return result;
};
